<template>
    <div class="heading" v-bind:class="{ 'heading--light': light }">
        <h1>{{ text }}</h1>
    </div>
</template>

<script>
    export default {
        name: 'Heading',
        props: {
            text: String,
            light: Boolean
        }
    }
</script>

<style lang="scss" scoped>

    .heading {
        margin-bottom: 6rem
    }
    
    h1 {
        position: relative;
        width: 100%;
        padding-bottom: 2.5rem;
        margin: 0;
        line-height: 1.6;
        text-align: center;
        text-transform: uppercase;
        font-family: 'Roboto Slab', sans-serif;
        font-weight: 400;
        font-size: 3.5rem;

        &::after {
            position: absolute;
            left: calc(50% - 118px);
            bottom: 0;
            display: block;
            width: 236px;
            height: 13px;
            background-image: url('~@/assets/decorator.png');
            content: "";
        }
    }

    .heading--light {

        h1 {
            color: #fff;

            &::after {
                background-image: url('~@/assets/decorator-light.png');
            }
        }
    }

    @media (max-width: 767px) {

        .heading {
            margin-bottom: 4rem;
        }

        h1 {
            font-size: 2.5rem;
        }
    }

</style>
